import { IRepository } from '@/types';
import { IDirectoryDiffResponse } from '@/lib/diffApi';
import DiffEntry from './DiffEntry';
import Cardlist from '@/ui/CardList';

import * as Icon from '@/ui/Icon';
import { Card, Row } from '@/ui/primatives';

import DebugJson from '@/ui/DebugJson';

import { IRepositoryCompareEntry } from '@/lib/repositoryCompareApi';

import FileChangeCountTags from '@/components/Repository/DiffView/FileChangeCountTags';
import DirectoryFileTypeChangeSet from '@/components/Repository/DiffView/DirectoryFileTypeChangeSet';
import { colors } from '@/styles';

const CurrentFolderSummary: React.FC<{ folderEntry: IRepositoryCompareEntry }> = ({ folderEntry }) => {
  return (
    <Card compressed style={{ padding: 10, background: colors.secondary.lightGray1 }}>
      <Row alignItems="center" justifyContent="space-between">
        <Row alignItems="center" gap={10}>
          <Icon.GithubFolder open /> {folderEntry.filename || '/'}
        </Row>
        <FileChangeCountTags entry={folderEntry} />
      </Row>
      <DirectoryFileTypeChangeSet entry={folderEntry} />
    </Card>
  );
};

const DirectoryDiff: React.FC<{
  repository: IRepository;
  response: IDirectoryDiffResponse;
  onFolderSelect: (path: string) => void;
}> = ({ repository, response, onFolderSelect }) => {
  const selfNode = response.compare.self;
  const entries = response.compare.entries;
  return (
    <>
      <Cardlist compressed>
        <CurrentFolderSummary folderEntry={selfNode} />
        <DebugJson json={selfNode} rootNodeName="selfNode" />
        <DebugJson json={entries} rootNodeName="entries" />
        {entries.map((entry) => (
          <DiffEntry
            namespace={repository.namespace}
            repositoryName={repository.name}
            onFolderSelect={onFolderSelect}
            entry={entry}
            key={entry.filename}
          />
        ))}
      </Cardlist>
    </>
  );
};

export default DirectoryDiff;
